import React from "react";
import AllSubjectTopics from "../../../Topics/AllSubjectTopics";


function MnemonicChemTopics() {
  return (
    <>

      <AllSubjectTopics subject="chemistry" type="mnemonic" />


    </>
  );
}

export default MnemonicChemTopics;